module.exports = __webpack_public_path__ + "static/img/file_r.48da27a8.png";